import {jwtDecode} from "jwt-decode";
import sign from "jwt-encode";

export const LS_TOKEN: string = process.env.VUE_APP_LS_TOKEN || 'SCAPIN-TOKEN';
export const LS_PUBKEY: string = process.env.VUE_APP_LS_PUBKEY || 'SCAPIN-PK';

const LS_DBID = process.env.VUE_APP_LS_DBID || 'SCAPIN-DBID';

interface TokenData {
  authid: string;
  isadmin: boolean;
}

export function TokenData(): TokenData | null {
  return verifToken(localStorage.getItem(LS_TOKEN) || '');
}

export function setDbId(dbid: string) {
  localStorage.setItem(LS_DBID, dbid)
}

export function getDbId() {
  const b = localStorage.getItem(LS_DBID)
  return b ? b : ''
}

export function encodeService(payload: any) {
  const publickey = localStorage.getItem(LS_PUBKEY)
  if (publickey) {
    return sign(payload, publickey)
  } else {
    return null
  }
}

export function decodeService(token: string) {
  return jwtDecode(token)
}

function verifToken(token: string): TokenData | null {
  try {
    // console.log('token=', token, ' publickey=', publicKey);
    const decod = jwtDecode(token)
    // console.log('decod :', decod)
    return decod as TokenData | null

  } catch (e) {
    return null;
  }
}
